<div class="otp-container">
  <app-mobile-header [title]="'menu.otp.verification'" [isShowBackButton]="showHeaderBackBtn"
    [manualBackEvent]="true" (onManualBackEvent)="onClickBack()"></app-mobile-header>

  <div class="otp-content">
    <div class="otp-mascot">
      <img src="assets/generalImage/user.svg" loading="lazy" alt="mascot" />
      <h1>{{ "desc.enter.otp" | translate }}</h1>
      <div class="mobileNo" *ngIf="mobileNo" (click)="changeOtpPhone()">
        <h1>+{{mobileNo}}</h1>
        <i class="icon-edit"></i>
      </div>
    </div>

    <div class="otpform">
      <app-otp-form [isPhoneNoExist]="isPhoneNoExist" [loginForm]="loginForm" [isSignUpForm]="isSignUpForm"
        [isQueue]="isQueue" (onShowBackBtn)="onShowBackBtn($event)"></app-otp-form>
    </div>

    <app-button [textButton]="true" [buttonName]="'button.continue.as.guest'"
      (onClickEvent)="onClickContinueAsGuest()" class="continueAsGuestww-btn" *ngIf="showContinueAsGuest"></app-button>
  </div>
</div>
